function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 10.74C12.5 11.986 11.486 13 10.24 13H3.76C2.514 13 1.5 11.986 1.5 10.74V4.26C1.5 3.014 2.514 2 3.76 2H5V0.5H3.76C1.684 0.5 0 2.184 0 4.26V10.739C0 12.816 1.684 14.499 3.76 14.499H10.239C12.316 14.499 13.999 12.815 13.999 10.739V9.5H12.499V10.74H12.5ZM7.25 0.5C6.836 0.5 6.5 0.836 6.5 1.25C6.5 1.664 6.836 2 7.25 2H11.439L5.47 7.97C5.177 8.263 5.177 8.738 5.47 9.031C5.616 9.177 5.808 9.251 6 9.251C6.192 9.251 6.384 9.178 6.53 9.031L12.5 3.061V7.25C12.5 7.664 12.836 8 13.25 8C13.664 8 14 7.664 14 7.25V0.5H7.25Z",
  fill: "#9296AD"
});

function SvgOpenLinkLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenLinkLight);
export default __webpack_public_path__ + "static/media/open-link-light.015935d1.svg";
export { ForwardRef as ReactComponent };